<template>
  <div id="publishing-affiliations-add">
    <ipub-model :title="`${inputData.firstName} ${inputData.lastName}`"
                width="600px"
                :visable="isVisable"
                @cancel="cancel"
                :showFooter="false">
      <div class="ipub-p4 font-color"
           v-if="inputData.corresponded">Correspondence Author</div>
      <div class="ipub-p4 font-color"
           v-if="inputData.email">
        <ipub-icon style="font-size:18px"
                   type="iconEmail" />
        <a class="link-color mar-l-10"
           :href="'mailto:'+inputData.email">{{inputData.email}}</a>
      </div>
      <div class="ipub-p4 font-color mar-b-30"
           v-if="inputData.orcid">
        <a target="_blank"
           :href="'https://orcid.org/'+inputData.orcid">
          <ipub-icon style="color:#a6ce39;font-size:18px"
                     type="iconORCID" />
          <font class="mar-l-10">{{inputData.orcid}}</font>
        </a>
      </div>
      <div class="relative">
        <ipub-button type="primary">
          View Author Publications
        </ipub-button>
        <div class="right-option tr ipub-p4 font-color">
          <div>You can also search this author in</div>
          <div>
            <a target="_blank"
               class="link-color"
               :href="`https://pubmed.ncbi.nlm.nih.gov/?term=${inputData.firstName}+${inputData.lastName}`">PubMed</a> | <a class="link-color"
               target="_blank"
               :href="`https://scholar.google.com.hk/scholar?q=${inputData.firstName}+${inputData.lastName}`">Google Scholar</a>
          </div>
        </div>
      </div>
    </ipub-model>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    },
  },
  data () {
    return {
      params: {},
      rules: {},
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
      journalId: 'getJournalId',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
      } else {
        this.params = Object.assign(this.params, this.inputData)
      }
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
